// ChatTypeSection.tsx
import React from 'react'
import { useTranslation } from 'react-i18next'

const ChatTypeSection = ({ visibleChats, chatDisabled, openNewConversation, loadTeacher, loadCounselor, loadSos }) => {
    const { t } = useTranslation()

    return (
        <div className="chat-types">
            <div className="chat-type-title" style={{ color: visibleChats ? '#153c4f' : '#ffffff' }}>
                Chats
            </div>
            <div className="chat-types-buttons">
                <button className={`chat-type-btn teacher-btn`} onClick={() => openNewConversation(loadTeacher, 'teacher')}>
                    {t('teacher')}
                </button>
                <button
                    className={`chat-type-btn counselor-btn ${chatDisabled ? 'disabled-chat-button' : ''}`}
                    onClick={() => openNewConversation(loadCounselor, 'counselor')}
                    disabled={chatDisabled}
                >
                    {t('counselor')}
                </button>
                <button
                    className={`chat-type-btn sos-btn ${chatDisabled ? 'disabled-chat-button' : ''}`}
                    onClick={() => openNewConversation(loadSos, 'sos')}
                    disabled={chatDisabled}
                >
                    {t('sos')}
                </button>
            </div>
        </div>
    )
}

export default ChatTypeSection
